<template>
  <b-card :class="$route.path.includes('dashboard') ? 'h-100' : ''">
    <b-card-header class="p-0 pb-2">
      <b-card-title>
        <h4>آخرین فاکتور ها</h4>
      </b-card-title>
    </b-card-header>

    <div class="d-flex flex-wrap" v-if="$route.path.includes('dashboard')">
      <b-form-group
        label="فیلتر بر اساس"
        class="mb-1 col-12 col-md-4 pr-md-2 px-0"
      >
        <select-box
          v-model="auditable_type"
          label="text"
          class="w-100"
          select="val"
          :lists="types"
          searchable
        />
      </b-form-group>
      <b-form-group
        v-if="auditable_type"
        class="mb-1 col-md-8 col-12 pr-md-2 px-0"
        label="انتخاب شناسه"
      >
        <select-box
          v-model="auditable_id"
          label="text"
          class="w-100"
          select="id"
          :url="auditable_type"
          searchable
        />
      </b-form-group>
    </div>
    <data-table
      :fields="fields"
      :items="invoices"
      :loading="loading"
      @onRowClicked="
        $router.push({
          name: 'show-invoice',
          params: { id: $event.id },
        })
      "
    >
      <template #user="{ data }">
        <span style="white-space: nowrap">
          {{ data.item.user.first_name + " " + data.item.user.last_name }}
        </span>
      </template>
      <template #created_at="{ data }">
        {{ calcDate(data.item.created_at) }}
      </template>
      <template #final_amount="{ data }">
        <span class="text-success">
          {{ numberWithCommas(data.item.final_amount) }} تومان
        </span>
      </template>
      <template #transaction="{ data }">
        {{ checkTransaction(data.item) }}
      </template>
      <template #item="{ data }">
        <div
          v-if="
            data.item.items &&
            data.item.items.items &&
            data.item.items.items.length
          "
          style="white-space: nowrap"
        >
          <template v-if="data.item.items.items[0].model_type == 'penalty'">
            <b-badge class="my-50" variant="danger">جریمه</b-badge>
            <div>دوره : {{ data.item.items.items[0].model.course.name }}</div>
            <div class="my-50">
              جلسه : {{ data.item.items.items[0].model.session.name }}
            </div>
            <div>
              تمرین : {{ data.item.items.items[0].model.exercise.title }}
            </div>
          </template>
          <template v-else>
            {{ data.item.items.items[0].model.name }}
          </template>
        </div>
        <span v-else>'-'</span>
      </template>
      <!-- <template #detail="{ data }">
        <b-button
          size="sm"
          variant="flat-secondary"
          @click="data.toggleDetails"
        >
          <span class="ml-50">مشاهده جزییات</span>
        </b-button></template
      > -->
      <template #status="{ data }">
        <b-badge
          :variant="
            data.item.status == 0
              ? 'info'
              : data.item.status == 1
              ? 'warning'
              : data.item.status == 2
              ? 'success'
              : 'danger'
          "
          >{{
            data.item.status == 0
              ? "در انتظار پرداخت"
              : data.item.status == 1
              ? "در حال پرداخت"
              : data.item.status == 2
              ? "پرداخت شده"
              : "لغو شده"
          }}
        </b-badge>
        <b-button
          class="ml-2"
          size="sm"
          v-if="data.item.status == 0"
          variant="success"
          :to="{ name: 'checkout', query: { invoice_id: data.item.id } }"
          >پرداخت</b-button
        >
      </template>
      <template #actions="{ data }">
        <b-button
          size="sm"
          variant="flat-primary"
          :to="{
            name: 'show-invoice',
            params: { id: data.item.id },
          }"
          style="white-space: nowrap"
        >
          <feather-icon icon="EyeIcon" />
          <span class="ml-50">مشاهده</span>
        </b-button>
      </template>
      <!-- <template #row-details="{ data }"> </template> -->
    </data-table>

    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div
        class="col-md-12 ml-auto d-flex justify-content-md-center align-items-center"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="mt-1 mb-0 d-flex justify-content-center"
        ></b-pagination>
      </div>
    </div>
    <!-- <b-modal v-model="visible" hide-footer>
      <div class="my-1" v-if="invoiceStatus.message">
        {{ invoiceStatus.message }}
      </div>

      <div class="my-1" v-if="invoiceStatus.transaction_id">
        شناسه تراکنش‌: {{ invoiceStatus.transaction_id }}
      </div>
      <div class="my-1" v-if="invoiceStatus.reference_code">
        کد پیگیری : {{ invoiceStatus.reference_code }}
      </div>

      <div v-if="invoiceStatus.amount" class="my-1">
        مبلغ : {{ numberWithCommas(invoiceStatus.amount) + " " + "تومان" }}
      </div>
    </b-modal> -->
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormCheckbox,
  BForm,
  BFormInput,
  BFormGroup,
  BCardHeader,
  BCardTitle,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BCard,
    VBModal,
    BBadge,
    BPagination,
    BLink,
    BAvatar,
    BFormCheckbox,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    SelectBox,
    BCardHeader,
    BCardTitle,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      invoices: [],
      search: "",
      loading: false,
      url: "/panel/invoices",
      currentPage: 1,
      pagination: {},
      visible: false,

      fields: [
        { key: "user", label: "نام کاربر" },
        { key: "created_at", label: "تاریخ فاکتور" },
        { key: "final_amount", label: "مبلغ نهایی فاکتور" },
        //   { key: "transaction", label: "کد پیگیری پرداخت" },
        //   { key: "item", label: "شرح" },
        { key: "status", label: "وضعیت" },
        //   { key: "actions", label: "عملیات" },
      ],
      types: [
        {
          id: 1,
          text: "ترم",
          val: "semester",
        },
        {
          id: 2,
          text: "دوره",
          val: "course",
        },
      ],

      auditable_type: "",
      auditable_id: "",
    };
  },
  watch: {
    currentPage(val) {
      this.getInvoices(val);
    },
    auditable_type(val) {
      this.auditable_id = "";
    },
    auditable_id(val) {
      if (this.auditable_type == null) {
        this.getInvoices();
      }
      if (this.auditable_type && val) {
        this.getInvoices();
      }
    },
  },
  async created() {
    this.getInvoices();
  },

  methods: {
    async getInvoices(page) {
      this.loading = true;
      try {
        let filters = {};
        if (this.$route.path.includes("dashboard")) {
          this.auditable_type &&
            this.auditable_id &&
            (filters[`${this.auditable_type}_id`] = this.auditable_id);
        }

        if (this.$route.path.includes("semesters")) {
          filters = {
            semester_id: this.$route.params.id,
          };
        } else if (this.$route.path.includes("users")) {
          filters = {
            user_id: this.$route.params.id,
          };
        }
        const { data } = await this.$http.get(this.url, {
          params: {
            includes: [
              "user",
              "items.model.exercise",
              "items.model.session",
              "items.model.course",
              "transactions",
            ],
            per_page: 8,
            page: page || 1,
            filters: {
              ...filters,
            },
          },
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.invoices = data.data.invoices;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
.vpd-input-group {
  .vpd-icon-btn {
    margin-bottom: 0;
  }
  .form-control {
    border-radius: 0 5px 5px 0;
  }
}
</style>
